export const JAT_DIFF_LABELS = { baixa: "Baixa", media: "Média", alta: "Alta", muito_alta: "Muito alta" };

export const JAT_DIFF_HELP = [
  {
    key: "baixa", dot: "bg-emerald-500", title: "Baixa complexidade",
    text: "Peça simples, com formato regular e fácil acesso às superfícies. Poucos detalhes, cantos ou áreas de difícil acesso. Sem necessidade de proteção ou mascaramento especial.",
  },
  {
    key: "media", dot: "bg-yellow-500", title: "Média complexidade",
    text: "Peça com alguns detalhes, rebaixos, furos, cantos ou superfícies de acesso moderado. Pode exigir cuidado adicional para atingir todas as áreas, mas sem grande dificuldade de preparação.",
  },
  {
    key: "alta", dot: "bg-orange-500", title: "Alta complexidade",
    text: "Peça com geometria irregular, muitos detalhes, furos, rebaixos ou áreas de difícil acesso. Pode exigir jateamento em várias posições, maior tempo de preparação ou proteção de determinadas regiões.",
  },
  {
    key: "muito_alta", dot: "bg-red-500", title: "Muito alta complexidade",
    text: "Peça com geometria complexa, muitos detalhes e áreas de difícil ou limitado acesso. Pode exigir desmontagem, mascaramento/proteção de várias regiões, posicionamento especial, jateamento manual detalhado ou várias etapas para concluir o serviço.",
  },
];

export const JAT_CHARACTERISTICS = [
  { key: "muitos_furos", label: "Muitos furos" },
  { key: "furos_profundos", label: "Furos profundos" },
  { key: "rebaixos", label: "Rebaixos/cavidades" },
  { key: "cantos_dificeis", label: "Cantos de difícil acesso" },
  { key: "geometria_irregular", label: "Geometria irregular" },
  { key: "mascaramento", label: "Necessidade de mascaramento" },
  { key: "areas_protegidas", label: "Áreas que não podem ser jateadas" },
  { key: "peca_delicada", label: "Peça delicada" },
  { key: "desmontagem", label: "Necessidade de desmontagem" },
  { key: "outro", label: "Outro" },
];

export const jatCharLabel = (key) =>
  (JAT_CHARACTERISTICS.find((c) => c.key === key) || {}).label || key;
